import React from 'react';
import TagManager from 'react-gtm-module';
import { EMPLOYERS_REDUCING } from '../content/stats';
import { FUNNEL_FIELDS } from '../funnelConfig';
import { useFunnel } from '../FunnelContext';
import LandingDisclaimer from './LandingDisclaimer';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

const HeroSectionNew = () => {
  const { goNext, handleAnswer, currentStep } = useFunnel();
  const { question, options } = currentStep.data;

  const handleClick = (jobArea) => {
    TagManager.dataLayer({
      dataLayer: { event: 'dl_select_goal', goal: jobArea, ...FUNNEL_FIELDS },
    });
    handleAnswer(jobArea);
    goNext();
  };

  return (
    <>
      <Header />
      <div className="App__content">
        <main className="text-center max-w-[600px] mx-auto px-4 py-8">
          <h1 className="text-[2rem] font-bold text-brand-charcoal mb-2 leading-tight">
            Is your job safe from AI?
          </h1>
          <p className="text-base text-[#666] mb-4">
            Take the 2-minute test and get your AI Fluency Score
          </p>
          <p className="text-lg font-bold text-[#dc2626] bg-white border border-black/10 rounded-xl p-4 max-w-[420px] mx-auto mb-6">
            {EMPLOYERS_REDUCING}
          </p>
          <p className="text-base font-semibold text-brand-charcoal mb-4">{question}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-[520px] mx-auto">
            {options.map((option) => (
              <button
                key={option}
                className="w-full py-4 px-4 text-[15px] font-semibold rounded-xl border-2 border-brand-green-dark bg-white text-brand-green-dark cursor-pointer transition-all hover:bg-brand-green-dark hover:text-white"
                onClick={() => handleClick(option)}
              >
                {option}
              </button>
            ))}
          </div>
        </main>
      </div>
      <LandingDisclaimer />
      <Footer />
    </>
  );
};

export default HeroSectionNew;
